import type { InGameCommStyle } from 'generated/openapi';
import { z } from 'zod';

const inGameCommStylesEnum = z.enum<InGameCommStyle[]>([
  'CHILL_BANTER',
  'IGL',
  'INFO_ONLY',
  'LISTENER',
  'STRATEGIC',
  'VENTING',
  'VOCAL',
]);

export interface InGameCommStyleOption {
  id: InGameCommStyle;
  label: string;
}

export const IN_GAME_COMM_STYLE_MAP = new Map<
  InGameCommStyle,
  InGameCommStyleOption
>([
  [
    'STRATEGIC',
    {
      id: 'STRATEGIC',
      label: '🎯 Strategic',
    },
  ],
  [
    'INFO_ONLY',
    {
      id: 'INFO_ONLY',
      label: 'ℹ️ Info only',
    },
  ],
  [
    'CHILL_BANTER',
    {
      id: 'CHILL_BANTER',
      label: '😎 Chill Banter',
    },
  ],
  [
    'IGL',
    {
      id: 'IGL',
      label: '🎵 IGL',
    },
  ],
  [
    'VOCAL',
    {
      id: 'VOCAL',
      label: '🗣️ Vocal',
    },
  ],
  [
    'LISTENER',
    {
      id: 'LISTENER',
      label: '👂 Listener',
    },
  ],
  [
    'VENTING',
    {
      id: 'VENTING',
      label: '😤 Venting',
    },
  ],
]);

export const IN_GAME_COMM_STYLE_OPTIONS: InGameCommStyleOption[] = Array.from(
  IN_GAME_COMM_STYLE_MAP.values(),
);

export const inGameCommStyleSchema = z
  .array(inGameCommStylesEnum)
  .min(1, { message: 'Pick at least one communication style' })
  .max(3, { message: 'Pick at most 3 communication styles' });
